import { useEffect } from "react";
import useLiveResource from "../../hooks/useLiveResource";

export default function useJobResource(loader) {
  const resource = useLiveResource(loader, { items: [], total: 0 }, true);
  const { refresh } = resource;
  useEffect(() => {
    const changed = () => { refresh({ supersede: true }); };
    window.addEventListener("background-jobs-change", changed);
    return () => window.removeEventListener("background-jobs-change", changed);
  }, [refresh]);
  return resource;
}
